import React, { useState, useEffect } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_BASE } from "../utils/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "../pages/Product/Price.css";

function ProductAvailability() {
  const [products, setProducts] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  // flatten products + variants for DataTable
  const flattenData = products.flatMap((product) =>
    product.variants.map((variant) => ({
      productNumber: product.productNumber,
      productName: product.productName,
      categoryName: product.categoryName,
      subcategoryName: product.subcategoryName,
      unit: variant.unit,
      quantity: variant.quantity,
    }))
  );

  const filteredProducts = flattenData.filter(
    (item) =>
      item.productName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.productNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.categoryName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.subcategoryName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/products?limit=0`);
        setProducts(response.data.products);
      } catch (err) {
        console.error("Error fetching products:", err);
      }
    };
    fetchProducts();
  }, []);

  const getCurrentDateTime = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const exportAvailability = () => {
    const doc = new jsPDF();
    doc.text(`Product_Available - ${getCurrentDateTime()}`, 10, 10);

    const tableData = flattenData.map((item) => [
      item.productNumber,
      item.productName,
      item.categoryName,
      item.subcategoryName,
      item.unit,
      item.quantity,
    ]);

    doc.autoTable({
      startY: 20,
      head: [
        [
          "Product Number",
          "Product Name",
          "Category",
          "Subcategory",
          "Unit",
          "Quantity",
        ],
      ],
      body: tableData,
    });

    doc.save("Product_Availability.pdf");
  };

  const responsiveColumnHeader = (header, field) => (rowData) => (
    <div className="responsive-cell">
      <span className="responsive-header">{header}</span>
      <span className="responsive-value">{rowData[field]}</span>
    </div>
  );

  return (
    <Box sx={{ fontFamily: "Times New Roman" }}>
      <h1>Product Availability</h1>

      {/* Search Box */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 2,
          marginBottom: "10px",
        }}
      >
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearch}
          style={{
            width: "20%",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ccc",
            fontSize: "15px",
            fontFamily: `"Times New Roman", Times, serif`,
          }}
        />
      </div>


      <Box mb={2} mt={2}>
        <Button
          variant="contained"
          color="primary"
          onClick={exportAvailability}
          sx={{
            fontFamily: "Roboto",
            marginTop: "10px",
            minWidth: "100px",
            height: "40px",
          }}
        >
          Export All
        </Button>
      </Box>


      <DataTable
        value={filteredProducts}
        scrollable
        scrollHeight="450px"
        paginator
        rows={10}
        emptyMessage="No products found"
        className="datatable-scrollable"
      >
        <Column
          field="productNumber"
          header="Product Number"
          body={responsiveColumnHeader("Product Number", "productNumber")}
        />
        <Column
          field="productName"
          header="Product Name"
          body={responsiveColumnHeader("Product Name", "productName")}
        />
        <Column
          field="categoryName"
          header="Category"
          body={responsiveColumnHeader("Category", "categoryName")}
        />
        <Column
          field="subcategoryName"
          header="Subcategory"
          body={responsiveColumnHeader("Subcategory", "subcategoryName")}
        />
        <Column
          field="unit"
          header="Unit"
          body={responsiveColumnHeader("Unit", "unit")}
        />
        <Column
          field="quantity"
          header="Quantity"
          body={responsiveColumnHeader("Quantity", "quantity")}
        />
      </DataTable>
    </Box>
  );
}

export default ProductAvailability;
